<template>
<Panel  :toggleable="true" :collapsed="true" @toggle="panelToggle">
 <template #header>
   <p class="my-2"><span class="handle mr-2"><i class="pi pi-align-justify"></i> </span><b class="text-primary">{{category.name}}</b></p>
</template>

<template #icons>
    <button class="p-panel-header-icon p-link mr-2" @click="toggle">
        <span class="pi pi-ellipsis-h"></span>
    </button>
    <Menu id="config_menu" ref="menu" :model="menuitems" :popup="true" />
</template>

<ClickEditInputText  title="Kategori İsmi" :value="category.name" :valkey="category.id" @dataChanged="categoryChanged"></ClickEditInputText>

<div  v-for="language in languages" :key="language.id">
<ClickEditInputText  v-for="translation in category.translations" :key="translation.id" :title="language.name+ ' İsmi'" :value="translation.translation" :valkey="translation.id" @dataChanged="optiontranslationChanged" v-show="translation.language_id == language.id"></ClickEditInputText> 
</div>

<div class="pl-1">
 <hr>
<h4 class="text-primary"><b>{{category.name}}</b> <span class="font-normal">Alt Kategoriler</span></h4>
<draggable 
v-model="subcategories"
class="list-group" 
:group="category.id" 
@start="start" 
@end="end" 
@change="change"
v-bind="dragOptions"
item-key="id">

<template #item="{element}">
<CascadeCategoryBrandAttribute  :category="element" :key="element.id" :languages="languages"  @dataRenewed="renewData" :is_cascade="is_cascade"></CascadeCategoryBrandAttribute>
</template>
</draggable>
<ClickAddInputText  title="Yeni Ekle"  valkey="new_phrase" @newAdded="newCategoryAdded"></ClickAddInputText>

<template v-if="is_cascade">
 <hr>
<h4 class="text-primary"><b>{{category.name}}</b> <span class="font-normal">Seçenekler</span></h4>	

<draggable 
v-model="category.options"
class="list-group" 
:group="category.id" 
@start="start" 
@end="end" 
@change="changeOptions"
v-bind="dragOptions"
item-key="id">

<template #item="{element}">
<CascadeCategoryBrandAttributeOptions  :option="element" :key="element.id" :languages="languages"  @dataRenewed="renewData" ></CascadeCategoryBrandAttributeOptions>
</template>

</draggable>

<ClickAddInputText  title="Yeni Ekle"  valkey="new_phrase" @newAdded="newOptionAdded"></ClickAddInputText>
</template>





</div>






</Panel>


</template>

<script>
import CascadeCategoryBrandAttribute from "./CascadeCategoryBrandAttribute"
import CascadeCategoryBrandAttributeOptions from "./CascadeCategoryBrandAttributeOptions"
export default {

  name: 'CascadeCategoryBrandAttribute',
  props:["category","languages","is_cascade"],
  components:{CascadeCategoryBrandAttribute,CascadeCategoryBrandAttributeOptions},
  data () {
    return {
    	subcategories:[],
    	drag:false,
    	menuitems: [
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                command: () => {
                    this.deleteItem("custom_attribute_category",this.category.id)
                }
            },
        ],

    }
  },
  computed:{
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
  	dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.renewData()
  		}
  	}
  },
  methods:{
  	panelToggle(event)
  	{
  		console.log(event)
  		if(!event.value)
  		{
  			this.getSubs()
  		}
  	},
  	toggle(event) {
        this.$refs.menu.toggle(event);
    },
    async getSubs()
  	{
  		console.log("getSubs")
  		this.subcategories = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute_sub_categories/"+this.category.id)
  		console.log(this.subcategories)
  	},
  	categoryChanged(data)
  	{		
		let formdata = new FormData()
		formdata.append("name",data.value)
		this.generalSubmission(formdata,"custom_attribute/update_category/"+data.key,this.renewData)
  	},
  	renewData(response)
  	{
  		this.getSubs()
  		this.$emit("dataRenewed")
  	},
  	optiontranslationChanged(data)
  	{

		let formdata = new FormData()
		formdata.append("data",data.value)
		this.generalSubmission(formdata,"custom_attribute/update_category_translation/"+data.key,this.renewData)
  	},
  	newCategoryAdded(data)
    {
      let formdata = new FormData()
      formdata.append("name",data.value)
      formdata.append("parent",this.category.id)
      this.generalSubmission(formdata,"custom_attribute/store_category/"+this.category.customattribute_id,this.renewData)
    },
    newOptionAdded(data)
    {
      let formdata = new FormData()
      formdata.append("name",data.value)
      formdata.append("customattributecategory_id",this.category.id)
      this.generalSubmission(formdata,"custom_attribute/store_option/"+this.category.customattribute_id,this.renewData)
    },
    start(event)
    {
      /*
      console.log("start");
      console.log(event);
      console.log(this.datacontainer);*/

      this.drag = true
    },
    end(event)
    {   

      this.drag = false
    },
    changeOptions(event)
    {
      	let formdata = new FormData()
      	formdata.append("options",JSON.stringify(this.category.options))
      	this.generalSubmission(formdata,"custom_attribute/reorder_options",this.renewData)
    },
    change(event)
    {   
    	console.log(this.subcategories)
      	let formdata = new FormData()
      	formdata.append("categories",JSON.stringify(this.subcategories))
      	this.generalSubmission(formdata,"custom_attribute/reorder_categories",this.renewData)
    },
  }
}
</script>

<style lang="css" scoped>
	.handle{
		cursor: pointer;
	}
</style>